import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/account/integrations")({
  component: () => <Outlet />,
});
